<template>
  <LoaderComponent v-if="loadingData"></LoaderComponent>
  <div style="margin-left: 20px;margin-right: 20px;">
    <div style="display: flex; padding: 3px;" class="testoblu">
      <div v-if="breakpoint.current=='xs'" style="width: 80%;">{{ COLCOMPALIM }}</div>
      <div v-if="breakpoint.current=='xs'" style="width: 20%">{{ COLVALORE }} per {{ portion }}g</div>
      <div v-if="breakpoint.current!=='xs'" style="width: 25%;">{{ COLCOMPALIM }}</div>
      <div v-if="breakpoint.current!=='xs'" style="width: 165px">{{ COLVALORE }} per {{ portion }}g</div>
      <div v-if="breakpoint.current!=='xs'" style="width: 55px;">{{ COLFONTE }}</div>
      <div v-if="breakpoint.current!=='xs'" style="width: 55px;">{{ COLCODICE }}</div>
      <div v-if="breakpoint.current!=='xs'" style="width: 55px">{{ COLCLASSE }}</div>
      <div v-if="breakpoint.current!=='xs'" style="width: 35%;">{{ COLNOTE }}</div>
    </div>
    <div v-for="component in foodInfoDetail" :key="component.IdMacroF">
      <div style="padding: 3px;" class="testobold backgroudlist">
        {{ component.description }}
      </div>

      <div style="display: flex; padding: 3px;" class="testonormale" v-for="(detail, idx) in component.components"
        :key="detail.Origfdcd" :class="!iseven(idx) ? 'even' : ''">
        <div v-if="breakpoint.current=='xs'" style="width: 80%;"><span v-for="(id,idx) in detail.spaces" :key="idx">&nbsp;</span> {{ detail.dscomp }}<span v-if="detail.cnum.length > 0">, {{ detail.cnum }}</span></div>
        <div v-if="breakpoint.current=='xs'" style="width: 20%" class="bold">{{ calculateValue(detail.valore, portion, detail.nrDec, detail.cnum) }}</div>
        <div v-if="breakpoint.current!=='xs'" style="width: 25%;"><span v-for="(id,idx) in detail.spaces" :key="idx">&nbsp;</span> {{ detail.dscomp }}<span v-if="detail.cnum.length > 0">, {{ detail.cnum }}</span></div>
        <div v-if="breakpoint.current!=='xs'" style="width: 165px" class="bold">{{ calculateValue(detail.valore, portion, detail.nrDec, detail.cnum) }}</div>
        <div v-if="breakpoint.current!=='xs'" style="width: 55px;" :title="detail.dsfonte" class="link">{{ detail.codice }}</div>
        <div v-if="breakpoint.current!=='xs'" style="width: 55px;">{{ detail.cdfonte }}</div>
        <div v-if="breakpoint.current!=='xs'" style="width: 55px" :title="detail.dscat" class="link">{{ detail.cdcategoria }}</div>
        <div v-if="breakpoint.current!=='xs'" style="width: 35%;">{{ detail.note }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { useBreakpoint } from "vuestic-ui";
 
import api from "../js/apiConsts.js";
import { axiosPost } from "../js/apiService.js";
import LoaderComponent from "./LoaderComponent.vue";
import { getSTRING } from "@/js/utils";
import apiConsts from "../js/apiConsts.js";
export default {
  name: "FoodDetailComponent",
  props: ["id", "lang", "portion"],
  emits: { error: null},
  components: {
    LoaderComponent,
  },
  data() {
    return {
      language: this.lang.toLowerCase().trim() == apiConsts.DEFLANG ? 0 : 1,
      foodInfoDetail: null,
      loadingData: false,
      COLCOMPALIM: '',
      COLVALORE: '',
      COLFONTE: '',
      COLCODICE: '',
      COLCLASSE: '',
      COLNOTE: '',
      TITOLO: '',
      breakpoint : useBreakpoint()
    };
  },
  async mounted() {
    await this.loadFoodDetail();
    this.COLCOMPALIM = getSTRING(this.lang, 'COLCOMPALIM', "Componenti Alimentari");
    this.COLVALORE = getSTRING(this.lang, 'COLVALORE', "Valore");
    this.COLFONTE = getSTRING(this.lang, 'COLFONTE', "Fonte");
    this.COLCODICE = getSTRING(this.lang, 'COLCODICE', "Codice");
    this.COLCLASSE = getSTRING(this.lang, 'COLCLASSE', "Classe");
    this.COLNOTE = getSTRING(this.lang, 'COLNOTE', "Note");
    this.TITOLO = getSTRING(this.lang, "TITOLO", apiConsts.TITOLOAPP);
  },
  methods: {
    iseven(num) {
      return (num % 2) == 0;
    },
    calculateValue(value, portion, dec, um){
      if (value && portion) 
      {
        if (value!="tr")
        {
          var val= parseFloat(value); 
          if (um!="%")
          {
            return ((val / 100) * portion).toFixed(dec);
          }
          else {
            return val.toFixed(dec);
          }
        }
        else {
          return value;
        }
      }
       else {
         return value;
       }
    },
    async loadFoodDetail() {
      this.loadingData = true;
      await axiosPost(api.APIFoodComponents, {
        language: this.language,
        foodId: this.id,
      })
        .then((response) => {
          this.loadingData = false;
          let res = response.data;
          this.foodInfoDetail = null;
          if (res.success) {
            this.foodInfoDetail = res.foodComponents;
          } else {
            this.$emit('error', res.message);
          }
        })
        .catch((err) => {
          this.loadingData = false;
          this.$emit('error', err.message);
        });
    },
  },
};
</script>

<style scoped>
.even {
  background-color: azure;
}
</style>